<template>
  <v-alert :value="value" type="warning">
    Column is not implemented at the moment
  </v-alert>
</template>
<script>
  export default {
    props: {
      value: {
        type: Boolean,
        default: false,
      },
    },
  }

</script>
